<template>
  <div>
    <div v-if="totalResponsible" class="grid_responsible_header">
      <div class="cell justify-center text-center">{{ localStorage.translations.pages['setting-personal_area'].labels['imya'] }}</div>
      <div class="cell justify-center text-center">{{ localStorage.translations.pages.projects['reports_table']['preliminary'] }}</div>
      <div class="cell justify-center text-center">{{ t['responsible_approved'] }}</div>
    </div>
    <div v-else :class="responsibleTotalShow ? 'grid_header' : 'grid_header_no_responsible'">
      <div class="cell">{{ byDays ? t.date : t.position}}</div>
      <div class="cell">{{ t.project }}</div>
      <div class="grid_row">
        <div class="grid_quantity">
          <div class="cell justify-center text-center">{{ t['reported'] }}</div>
          <div class="cell">
            <div v-if="$slots.first" class="my-n1">
              <slot name="first"/>
            </div>
            <v-sheet color="transparent" width="100%" class="text-center">
              {{ t['invoiced'] }}
            </v-sheet>
          </div>
          <div class="cell justify-center text-center">{{ t['pay'] }}</div>
          <div class="cell justify-center text-center">{{ t['rate'] }}</div>
          <div class="cell justify-center text-center">{{ localStorage.translations.pages.finance['invoice-table']['sum'] }}</div>
        </div>
        <div class="cell justify-center text-center">{{ t.quantity }}</div>
      </div>
      <template v-if="responsibleTotalShow">
        <div class="grid_row responsible_header_cell">
          <div class="cell justify-center text-center">{{ localStorage.translations.pages['sales_project']['planned_resources-responsible_employees'].main }}</div>
          <div class="grid_charge">
            <div class="cell justify-center text-center">{{ t['rate'] }}</div>
            <div class="cell">
              <div v-if="$slots.second" class="my-n1">
                <slot name="second"/>
              </div>
              <v-sheet color="transparent" width="100%" class="text-center">
                {{ t['premium'] }}
              </v-sheet>
            </div>
            <div class="cell justify-center text-center">{{ localStorage.translations.pages['setting-personal_area'].labels['imya'] }}</div>
          </div>
        </div>
      </template>
      <template v-if="byDays">
        <div class="grid_days_inner_note">
          <div class="cell">{{ t.work }}</div>
          <div class="cell">{{ t.notes }}</div>
        </div>
      </template>
      <div v-else class="cell">{{ t.work }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FinanceSalarySliceShowTableHeader",
  props: {
    totalResponsible: Boolean,
    responsibleTotalShow: Boolean,
    checkResponsible: Boolean,
    byDays: Boolean
  },
  computed: {
    t() {
      return this.localStorage.translations.pages.finance['period-table']
    }
  }
}
</script>
